import { createApi } from "@reduxjs/toolkit/query/react";
import fetchBaseQueryCSRF from "../helper";

// Competitive Intelligence API (ads)
const competitiveIntelligence = createApi({
    baseQuery: fetchBaseQueryCSRF({ baseUrl: CROSS_API_URL }),
    reducerPath: "api.competitiveIntelligence",
    tagTypes: ["competitiveIntelligence"],
    endpoints: (builder) => ({
        // Right panel (PLA jackpot)
        getAdsRightPanelGlobal: builder.query<any, {
            startDate: string | null,
            endDate: string | null,
            device: string[] | null,
            countries: string[],
            domain: string,
            workspaceTable: any,
            workspaceId?: any,
            keywords: string[],
            page?: number,
            pageSize?: number,
            otherDomains?: string[],
            brands?: string[],
            domains?: string[],
            sortBy?: string,
            sortOrder?: string,
            search?: string,
            impressionShare?: [number, number],
            position?: [number, number],
            platform: any
        }>({
            query: ({ startDate, endDate, device, countries, domain, workspaceTable, workspaceId, keywords, otherDomains, brands, domains, sortBy, sortOrder, search, impressionShare, position, platform }) => {
                const url = `/competitiveIntelligence/ads/getAdsRightPanelGlobal`;
                const [frequency_min, frequency_max] = impressionShare ?? [0, 100];
                const [average_position_min, average_position_max] = position ?? [0, 10];
                const body: any = {
                    startDate,
                    endDate,
                    device,
                    countries,
                    // Backend SQL lit @country (singulier). On envoie aussi countries pour compat
                    country: (countries && countries.length > 0) ? countries[0] : null,
                    domain,
                    workspaceTable,
                    workspaceId,
                    keywords: keywords ?? [],
                    platform: platform ?? [],
                    frequency_min,
                    frequency_max,
                    average_position_min,
                    average_position_max,
                    price_min: 0,
                    price_max: 50000,
                    domains: domains ?? [],
                    friendly_domains: [],
                    otherDomains,
                    brands,
                    sortBy,
                    sortOrder,
                    search,
                };
                return {
                    url,
                    method: "POST",
                    body: JSON.stringify(body),
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache",
                        Accept: "application/json",
                    },
                };
            },
        }),

        // PLA ads (TOP_PLA)
        getAdsPlaCompetitiveIntelligence: builder.query<any, {
            startDate: string | null,
            endDate: string | null,
            device: string[] | null,
            countries: string[],
            keywords: string[],
            workspaceTable?: any,
            workspaceId?: any,
            domain?: string,
            platform: any
        }>({
            query: ({ startDate, endDate, device, countries, keywords, workspaceTable, workspaceId, domain, platform }) => {
                const url = `/competitiveIntelligence/ads/getAdsPlaCompetitiveIntelligence`;
                const body = {
                    startDate,
                    endDate,
                    device,
                    countries,
                    keywords,
                    workspaceTable,
                    workspaceId,
                    domain,
                    platform,
                };
                return {
                    url,
                    method: "POST",
                    body: JSON.stringify(body),
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache",
                        Accept: "application/json",
                    },
                };
            },
        }),

        // Text ads (TOP_TXT)
        getTextAds: builder.query<any, {
            startDate: string | null,
            endDate: string | null,
            device: string[] | null,
            countries: string[],
            keywords: string[],
            workspaceTable?: any,
            workspaceId?: any,
            domain?: string,
            platform: any
        }>({
            query: ({ startDate, endDate, device, countries, keywords, workspaceTable, workspaceId, domain, platform }) => {
                const url = `/competitiveIntelligence/ads/getTextAds`;
                const body = {
                    startDate,
                    endDate,
                    device,
                    countries,
                    keywords,
                    workspaceTable,
                    workspaceId,
                    domain,
                    platform,
                };
                return {
                    url,
                    method: "POST",
                    body: JSON.stringify(body),
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache",
                        Accept: "application/json",
                    },
                };
            },
        }),

        // Side queries (top competitors global + by ad when adType provided)
        getSideQueries: builder.query<any, {
            startDate: string | null,
            endDate: string | null,
            device: string[] | null,
            countries: string[],
            keywords: string[],
            workspaceTable?: any,
            workspaceId?: any,
            domain?: string,
            platform: any,
            adType?: string[]
        }>({
            query: ({ startDate, endDate, device, countries, keywords, workspaceTable, workspaceId, domain, platform, adType }) => {
                const url = `/competitiveIntelligence/ads/getSideQueries`;
                const body = {
                    startDate,
                    endDate,
                    device,
                    countries,
                    keywords,
                    workspaceTable,
                    workspaceId,
                    domain,
                    platform,
                    adType,
                };
                return {
                    url,
                    method: "POST",
                    body: JSON.stringify(body),
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache",
                        Accept: "application/json",
                    },
                };
            },
        }),
    }),
});

export const {
    useGetAdsRightPanelGlobalQuery,
    useGetAdsPlaCompetitiveIntelligenceQuery,
    useGetTextAdsQuery,
    useGetSideQueriesQuery,
} = competitiveIntelligence;

export default competitiveIntelligence;


